// import { put } from "redux-saga/effects";
import { get, post, remove, put } from "../api_helper";
import * as url from "../url_helper";

const baseURL = process.env.REACT_APP_API_DOTNET_URL;

export const getDeductionplanDetails = (code) => get(`${baseURL + url.DEDUCTIONPLAN_BASE}/${code}`);
export const getDeductionplans = ({ page, pageSize }) => get(baseURL + url.DEDUCTIONPLAN_BASE + `?pageNumber=${page}&pageSize=${pageSize}`);

export const updateDeductionplan = (code, payload) => put(`${baseURL}${url.DEDUCTIONPLAN_BASE}/${code}`, payload, {
  headers: {
    'Content-Type': 'application/json',
  },
});

export const createDeductionplan = (payload) => post(baseURL + url.DEDUCTIONPLAN_BASE, payload);

export const deleteDeductionplan = (code) => remove(`${baseURL}${url.DEDUCTIONPLAN_BASE}/${code}`);

export const getAllDeductionPlanMaster = () => get(`${baseURL}${url.DEDUCTION_PLAN_MASTER}/GetAll`);

export const getCurrentPayPeriodMaster = () => get(`${baseURL}${url.PAY_PERIOD_MASTER}/GetCurrent`);

export const getFuturePayPeriods = () => get(`${baseURL}${url.PAY_PERIOD_MASTER}/GetFuturePayPeriods`);

export const getValidateMiscFlagData = (payload) => post(`${baseURL}${url.PAY_PERIOD_MASTER}/ValidatePreviousMiscFlagValues`, payload);

export const createDeductionPlanForEmployeeAPI = (payload) => post(`${baseURL}${url.EMPLOYEE_DEDUCTION_PLAN_BASE}/CreateOrUpdateApplicationWithDocument`, payload);